"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const Modal_1 = __importDefault(require("components/design-system/Modal"));
const ModalRemoveReviewer = ({ isReviewerWording, onSubmit, onCancel }) => {
    const reviewerWording = isReviewerWording ? 'reviewer' : 'reviewee';
    return (react_1.default.createElement(Modal_1.default, { customClass: "cursor-default w-[400px]", onClose: onCancel, minWidth: 400 },
        react_1.default.createElement(Modal_1.default.Header, { title: (0, HelperUtils_1.getObjectiveLocale)(`Are you sure want to remove the ${reviewerWording}(s)?`), onClose: onCancel }),
        react_1.default.createElement(Modal_1.default.Body, null,
            react_1.default.createElement("div", { className: "mx-[24px]" },
                react_1.default.createElement("p", { className: "text-n-800 typography-paragraph mb-8" }, (0, HelperUtils_1.getObjectiveLocale)(`By removing the ${reviewerWording}(s), all completed responses ${isReviewerWording ? 'from' : 'to'} the corresponding target will be permanently deleted.`)),
                react_1.default.createElement("p", { className: "text-n-800 font-semibold" }, (0, HelperUtils_1.getObjectiveLocale)(`This action cannot be undone.`)))),
        react_1.default.createElement(Modal_1.default.Footer, { useBorder: false, primaryButton: {
                text: 'Remove',
                onClick: onSubmit,
                dataCy: 'confirm'
            }, secondaryButton: {
                text: 'Cancel',
                onClick: onCancel
            } })));
};
exports.default = ModalRemoveReviewer;
